export const getCurrentSubdomain = () => {
  let pathArray = location.pathname.split('/');
  return pathArray[1] || "";
}
